(function () {
  'use strict';

  angular
    .module('back.forward.navi')
    .directive('backForwardNavi', backForwardNavi);

  backForwardNavi.$inject = [];

  function backForwardNavi() {
    var directive = {
      bindToController: true,
      controller: 'backForwardNaviCtrl',
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      template: require('../back.forward.navi/back.forward.navi.html'),
      replace: true,
    };
    return directive;

    function link(scope, element, attrs) {}
  }
})();
